import {call, fork, takeEvery} from 'redux-saga/effects';

import {getNewApplicationToken, setPasswordResetState} from 'modules/authentication/actions';
import {login} from 'modules/authentication/sagas/login';
import {passwordResetFlow, removeLocalResetId} from 'modules/authentication/sagas/passwordReset';
import {handleInitialRedirect, newApplicationToken} from 'modules/authentication/sagas/utility';

export default function* authSagas() {
    console.log('authentication saga started');

    yield fork(handleInitialRedirect);
    yield takeEvery(getNewApplicationToken, newApplicationToken);
    yield fork(login);
    yield takeEvery(setPasswordResetState, removeLocalResetId);
    yield fork(passwordResetFlow);
}
